import type { DesignDataProps, DesignHeaderProps } from "@/types/design/design.types";

export const designHeaderData: DesignHeaderProps = {
  titleTop: "Testimonial",
  title: "What Our Clients Say",
  description: "Real feedback from our customers who experienced our services.",
}

export const designData: DesignDataProps = {
  title: "Design",
  items: [
    {
      id: "item-1",
      title: "fresh-green",
      image: "/assets/design/freshgreen.avif",
      },
    {
      id: "item-2",
      title: "Studio Tag",
      image: "/assets/design/doublecream2.avif",
      },
    {
      id: "item-3",
      title: "revitalift",
      image: "/assets/design/revitalift.avif",
      },
    {
      id: "item-4",
      title: "fried-chicken",
      image: "/assets/design/friedchicken.avif",
      },
    {
      id: "item-5",
      title: "Kitchen",
      image: "/assets/design/doublecream1.avif",
      },
    {
      id: "item-6",
      title: "burger",
      image: "/assets/design/burger.avif",
      },
    {
      id: "item-7",
      title: "headphone-1",
      image: "/assets/design/headphone1.avif",
      },
    {
      id: "item-8",
      title: "eclipsed",
      image: "/assets/design/eclipsed.avif",
      },
    {
      id: "item-9",
      title: "watch-1",
      image: "/assets/design/watch1.avif",
      },
    {
      id: "item-10",
      title: "watch-2",
      image: "/assets/design/watch2.avif",
      },
    {
      id: "item-11",
      title: "nivea",
      image: "/assets/design/nivea.avif",
      },
    {
      id: "item-12",
      title: "airpod",
      image: "/assets/design/airpod1.avif",
      },
    {
      id: "item-13",
      title: "lenovo",
      image: "/assets/design/lenovo1.avif",
      },
    {
      id: "item-14",
      title: "caeliora-1",
      image: "/assets/design/caeliora1.avif",
      },
    {
      id: "item-15",
      title: "eye-cream-1",
      image: "/assets/design/eyecream1.avif",
      },
    {
      id: "item-16",
      title: "chanel",
      image: "/assets/design/chanel.avif",
      },
    {
      id: "item-17",
      title: "caeliora-2",
      image: "/assets/design/caeliora2.avif",
      },
    {
      id: "item-18",
      title: "eye-cream-2",
      image: "/assets/design/eyecream2.avif",
      },
    {
      id: "item-19",
      title: "food",
      image: "/assets/design/salad.avif",
      },
    {
      id: "item-20",
      title: "burger-2",
      image: "/assets/design/burger2.avif",
      },
    {
      id: "item-21",
      title: "supra",
      image: "/assets/design/supra.avif",
      },
    {
      id: "item-22",
      title: "chair",
      image: "/assets/design/chair1.avif",
      },
    {
      id: "item-23",
      title: "creatina",
      image: "/assets/design/creatina1.avif",
      },
    {
      id: "item-24",
      title: "headphone-2",
      image: "/assets/design/headphone2.avif",
      },
    {
      id: "item-25",
      title: "mro",
      image: "/assets/design/mro.avif",
      },
    {
      id: "item-26",
      title: "pizza",
      image: "/assets/design/pizza1.avif",
      },
    {
      id: "item-27",
      title: "prime",
      image: "/assets/design/prime.avif",
      },
    {
      id: "item-28",
      title: "headphone-3",
      image: "/assets/design/headphone3.avif",
      },
    {
      id: "item-29",
      title: "nike",
      image: "/assets/design/nike.avif",
      },
    {
      id: "item-30",
      title: "casio",
      image: "/assets/design/casio.avif",
      },
    {
      id: "item-31",
      title: "sting",
      image: "/assets/design/sting.avif",
      },
    {
      id: "item-32",
      title: "del-monte",
      image: "/assets/design/delmonte.avif",
      },
    {
      id: "item-33",
      title: "headphone-4",
      image: "/assets/design/headphone4.avif",
      },
    {
      id: "item-34",
      title: "strawberry",
      image: "/assets/design/strawberry1.avif",
      }
  ]
};
